import * as React from 'react';
import { connect } from 'react-redux';

import Form from './Form';

import IState from '../../interfaces/states';
import {
    SaveState as SaveStateActions,
    ReportTemplate as ReportTemplateActions,
} from '../../actions';
import { ReportTemplate } from '../../store/models';

interface IOwnProps {
    className?: string,
}

interface IStateProps {
    reportTemplate: ReportTemplate,
}

interface IDispatchProps {
    setName: Function,
    setDirty: Function,
}

type IProps = IOwnProps & IStateProps & IDispatchProps;

function onChange(name: string, value: any, props: IProps) {
    if (name === 'name') {
        props.setName(value);
        props.setDirty();
    }
}

const FormContainer: React.StatelessComponent<IProps> = (props: IProps) => {
    return <Form
        key="settings"
        className={props.className}
        reportTemplate={props.reportTemplate}
        onChange={(name, value) => onChange(name, value, props)} />;
}

FormContainer.propTypes = {
    isLoading: React.PropTypes.bool,
    reportTemplate: React.PropTypes.object.isRequired,
};

const mapStateToProps = (state: IState) => {
    const props = {
        reportTemplate: state.reportTemplate,
    }

    return props;
};

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    {
        setName: ReportTemplateActions.setName,
        setDirty: SaveStateActions.dirty,
    }
)(FormContainer);



// WEBPACK FOOTER //
// ./src/components/reportProperties/FormContainer.tsx